import { TOOL_CURSORS } from 'config/constants';
import { toCssCursor } from '../../modules/cursor';

/**
 * Common cursors used on the annotation elements
 */

// @ts-expect-error [EN-10263] - TS2345 - Argument of type '{ value: string; x?: number | undefined; y?: number | undefined; } | undefined' is not assignable to parameter of type '{ value: string; x?: number | undefined; y?: number | undefined; }'.
export const CURSOR_HANDLE: string = toCssCursor(TOOL_CURSORS.HANDLE);
// @ts-expect-error [EN-10263] - TS2345 - Argument of type '{ value: string; x?: number | undefined; y?: number | undefined; } | undefined' is not assignable to parameter of type '{ value: string; x?: number | undefined; y?: number | undefined; }'.
export const CURSOR_NODE: string = toCssCursor(TOOL_CURSORS.NODE);
